module.exports = __webpack_public_path__ + "static/media/whatsappBlastMobile.655b2c6d.png";